var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('van-icon',{staticClass:"arrow-left",attrs:{"name":"arrow-left"}}),_c('span',{staticClass:"back"},[_vm._v("返回")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }